import { createContext, useContext } from 'react'
import { TTenantSettings } from '../types/Tenant'
import { AuthContext } from './AuthContext'

// Settings do tenant logado, carregadas uma vez pelo MainLayout
type TTenantSettingsContext = {
  settings: TTenantSettings | null
  error: string
}

export const TenantSettingsContext = createContext<TTenantSettingsContext>({
  settings: null,
  error: '',
})

export type TFeatureAccess = 'loading' | 'allowed' | 'denied'

// Sysadmin na própria conta (sem session de produtor): vê disputas de todos
export const useIsDisputeAdminView = () => {
  const { session, isUserSysAdmin } = useContext(AuthContext)
  return isUserSysAdmin() && !session
}

// null/ausente conta como desligado: o admin libera produtor a produtor
export const useChargebackDisputeAccess = (): TFeatureAccess => {
  const { settings, error } = useContext(TenantSettingsContext)
  const isAdminView = useIsDisputeAdminView()
  if (isAdminView) return 'allowed'
  if (!settings) return error !== '' ? 'denied' : 'loading'
  return settings.enableChargebackDispute ? 'allowed' : 'denied'
}
